<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import BcSupplierApi from "@/services/bc-supplier-api";

export default {
  page: {
    title: "Commandes fournisseur",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },

  mounted() {
    this.sections.forEach(section => this.findBcFrsSupplier(section));
  },

  computed: {
    bcSupplierFields() {
      return [
        { key: "bcDate", label: "Date", tdClass: "align-middle font-weight-bold", thStyle: "minWidth: 120px;" },
        { key: "bcNumber", label: "N° BC", tdClass: "align-middle font-weight-bold", thStyle: "minWidth: 120px;" },
        { key: "frsName", label: "Nom fournisseur", tdClass: "align-middle", thStyle: "minWidth: 220px;" },
        { key: "bcType", label: "Type BC", tdClass: "align-middle", thStyle: "minWidth: 120px;" },
      ];
    }
  },

  data() {
    return {
      partnerCode: null,
      sections: [
        {
          type: "PARA",
          title: "Bons de commande PARA",
          list: [],
          isTableLoading: false,
          pagemodel: { currentPage: 1, perPage: 10, pageSize: 10, totalRows: 0 }
        },
        {
          type: "PHARMA",
          title: "Bons de commande PHARMA",
          list: [],
          isTableLoading: false,
          pagemodel: { currentPage: 1, perPage: 10, pageSize: 10, totalRows: 0 }
        }
      ]
    };
  },

  methods: {
    findBcFrsSupplier(section) {
      section.isTableLoading = true;

      BcSupplierApi.findBcFrsSupplier(
        section.pagemodel.currentPage,
        section.pagemodel.perPage,
        section.type,
        this.partnerCode
      )
        .then(result => {
          if (result) {
            section.list = result.list || [];
            section.pagemodel.totalRows = result.total || 0;
            section.pagemodel.currentPage = result.page || 1;
            section.pagemodel.perPage = result.pageSize || section.pagemodel.perPage;
            section.pagemodel.pageSize = result.pageSize || section.pagemodel.pageSize;
          }
        })
        .finally(() => {
          section.isTableLoading = false;
        });
    },
    refreshList(section) {
      section.pagemodel.currentPage = 1;
      this.findBcFrsSupplier(section);
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row p-sm-4">
      <div class="col-12">
        <div class="font-size-20 font-weight-bold mb-3">
          Bons de commande fournisseur
        </div>
      </div>

      <div v-for="section in sections" :key="section.type" class="col-12 mb-4">
        <div class="card">
          <div class="card-body">
            <div class="font-size-16 font-weight-bold mb-3">
              {{ section.title }}
            </div>

            <div class="table-responsive mb-0 mt-4" style="max-height:31em">
              <b-table
                :busy="section.isTableLoading"
                :striped="true"
                :small="true"
                :hover="true"
                :items="section.list"
                :fields="bcSupplierFields"
              >
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                  </div>
                </template>

                <template v-slot:cell(bcType)="{value}">
                    <b-badge class="font-weight-bold" v-if="value" :variant="value === 'URGENTE' ? 'danger' : 'light'">{{value}}</b-badge>
                </template> 



              </b-table>

              <span v-if="!section.isTableLoading && !section.list.length" class="d-flex justify-content-center m-4 text-danger">
                Aucune ligne trouvée
              </span>
            </div>

            <div v-if="section.pagemodel.totalRows" class="row pt-3 mb-sm-4">
              <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                  <b-form-select @input="refreshList(section)" v-model="section.pagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                  <div class="d-none d-lg-inline pt-1">
                    <span class="text-muted mb-0 ml-1">{{ $t('pagination.from') }}</span>
                    <span class="font-weight-bold"> {{ section.pagemodel.totalRows }} {{ $t('pagination.lines') }}</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="section.pagemodel.currentPage"
                      :per-page="section.pagemodel.pageSize"
                      :total-rows="section.pagemodel.totalRows"
                      @input="findBcFrsSupplier(section)"
                      :disabled="section.isTableLoading"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
